export default {
    // ================WaterGuru===================
    // REQUIRED - Amazon Cognito Identity Pool ID
    identityPoolId: 'us-west-2:691e3287-5776-40f2-a502-759de65a8f1c',
    // REQUIRED - Amazon Cognito Region
    region: 'us-west-2',
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: 'us-west-2_icsnuWQWw',
    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: '7pk5du7fitqb419oabb3r92lni',
    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: true,
    // OPTIONAL - Configuration for cookie storage
    cookieStorage: {
        // REQUIRED - Cookie domain (only required if cookieStorage is provided)
        domain: ~location.origin.indexOf('waterguru-prod.com') ? '.waterguru-prod.com' : '.waterguru.com',
        // OPTIONAL - Cookie path
        path: '/',
        // OPTIONAL - Cookie expiration in days
        expires: 365,
        // OPTIONAL - Cookie secure flag
        secure: true
    }
}
